import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LastTenTab } from 'src/app/modules/shared/entities/last-ten-tab.enum';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { StorageValues } from 'src/app/modules/shared/entities/storage-values.enum';
import { LnOrderStatus } from 'src/app/modules/shared/entities/ln-order-status.enum';
import { QuotesSearchComponent } from './quotes-search/quotes-search.component';
import { OpenQuotesComponent } from './open-quotes/open-quotes.component';

@Component({
  selector: 'app-last-ten',
  templateUrl: './last-ten.component.html',
  styleUrls: ['./last-ten.component.scss'],
  standalone: false
})
export class LastTenComponent implements OnInit {
  @Input() accountManagerEmployeeId: string;
  @ViewChild('openQuotes') openQuotes: OpenQuotesComponent;

  appStrings: AppLocalization;
  loading = false;
  isAccountManager = false;
  accountManagerId: string;
  cachedSearchValues: any;
  searchValue: string;
  isUploading = false;
  isOpen = false;
  activeTab = 0;
  tabs = LastTenTab;
  mobileToggleValues = [];
  mobileMenuOptions = [];

  constructor(
    private appInfoService: AppInfoService,
    private router: Router,
    private dialog: MatDialog,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.mobileMenuOptions =
      [
        { value: this.appStrings.button_seeAll, icon: 'visibility' },
        { value: this.appStrings.button_addNew, icon: 'add' }
      ];
    this.isAccountManager = this.appInfoService.isAccountManager();
    this.setupMobileToggleButtons();
    this.cachedSearchValues = JSON.parse(sessionStorage.getItem(StorageValues.CachedFilters + StorageValues.LastTenQuotesKey));
    this.searchValue = this.cachedSearchValues?.displayedSearchValue ?? this.appStrings.accounts_search;
  }

  toggleState() {
    this.isOpen = !this.isOpen;
  }

  onTabChange(index: number) {
    this.activeTab = index;
  }

  onTabChangeMobile(selectedTab: any) {
    this.activeTab = LastTenTab[selectedTab.value.split(' ').join('') as keyof typeof LastTenTab];
  }

  handleAddNew() {
    this.router.navigate(['/quotes/new']);
  }

  handleSeeAll() {
    if (this.activeTab === LastTenTab.OpenQuotes) {
      this.router.navigate(['/quotes']);
    } else {
      this.goToLnOrders();
    }
  }

  openSearch() {
    const dialog = this.dialog.open(QuotesSearchComponent, {
      panelClass: ['ds', 'fullWidth', this.deviceService.isMobile() ? 'fullScreen' : ''],
      data: { accountManagerId: this.accountManagerId },
    });

    dialog.afterClosed().subscribe((result) => {
      if (result?.performSearch) {
        this.openQuotes.getQuoteList();
        this.searchValue = result?.searchDisplay;
      }
    });
  }

  goToLnOrders() {
    const LNOrdersCachedFilters = sessionStorage.getItem(StorageValues.CachedFilters + StorageValues.LnOrderKey);

    const newStatus = this.activeTab === LastTenTab.LNSubmittedOrders ? LnOrderStatus.Closed : LnOrderStatus.All;

    if (LNOrdersCachedFilters) {
      const newCached = JSON.parse(LNOrdersCachedFilters);
      // Closed is the only status meaning Shipped
      newCached.lnOrderStatus = newStatus;
      sessionStorage.setItem(StorageValues.CachedFilters + StorageValues.LnOrderKey, JSON.stringify(newCached));
    } else {
      sessionStorage.setItem(StorageValues.CachedFilters + StorageValues.LnOrderKey, JSON.stringify({
        lnOrderStatus: newStatus,
        displayedSearchValue: ''
      }));
    }

    this.router.navigate(['/ln-orders']);
  }

  handleMenuAction(activeTab: any) {
    if (activeTab === this.mobileMenuOptions[0].value) {
      this.handleSeeAll();
    } else if (activeTab === this.mobileMenuOptions[1].value) {
      this.handleAddNew();
    }
  }

  private setupMobileToggleButtons() {
    this.mobileToggleValues = [{
      value: this.appStrings.menu_openQuotes
    }, {
      value: this.appStrings.menu_openOrders
    }, {
      value: this.appStrings.label_submittedOrders
    }];
  }
}
